// src/components/CurrencyConverterCard.ts
import "./CurrencyConverterCard.css";

export async function renderCurrencyConverterCard(
  container: HTMLElement,
  query: string,
): Promise<void> {
  container.innerHTML = `<div class="card-container currency-card">Loading...</div>`;

  const match = query.match(/([\d.]+)\s*(\w+)\s*to\s*(\w+)/i);

  if (!match) {
    container.innerHTML = `
      <div class="card-container currency-card">
        <div class="currency-error">Try: "10 USD to EUR"</div>
      </div>
    `;
    return;
  }

  const amount = parseFloat(match[1]);
  const from = match[2].toUpperCase();
  const to = match[3].toUpperCase();

  try {
    const res = await fetch(
      `https://api.ayesearch.com/api/currency/?from=${from}&to=${to}&amount=${amount}`,
    );
    const data = await res.json();

    container.innerHTML = `
      <div class="card-container currency-card">
        <div class="currency-line">
          <span class="currency-value">${amount} ${from}</span>
          <span class="currency-arrow">→</span>
          <span class="currency-result">${data.result} ${to}</span>
        </div>
        <div class="currency-note">Rate: ${data.rate}</div>
      </div>
    `;
  } catch {
    container.innerHTML = `
      <div class="card-container currency-card">
        <div class="currency-error">Unable to convert currency.</div>
      </div>
    `;
  }
}
